/**
 * @module FE-CU35_ログイン方法設定画面
 */
import Header from '@/components/header/Header.vue';
import MobileFooter from '@/components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NativeApi from '../../api/nativeApi';
import NativeCallback from '../../api/nativeCallback';

const PAGE_ID = 'FE-CU35';

export default {
  name: 'LoginSettings',
  components: {
    Header,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU35ログイン方法設定画面.ログイン方法設定'), // "ログイン方法設定",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU35ログイン方法設定画面.C0001'), //"ログイン方法を変更を行うことができます。\nご利用のスマートフォンによっては、生体認証がご利用になれない場合がございます。",
      marginBottom: 30,
      dialog: false,
      radioGroup: 1,
      radioItems: [
        {
          id: 1,
          label: vm.$vuetify.lang.t(
            '$vuetify.FECU35ログイン方法設定画面.ユーザーIDパスワードを毎回入力する'
          ), //"ユーザーID、パスワードを毎回入力する",
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU35ログイン方法設定画面.アプリを使用する際ユーザーIDとパスワードを入力のうえログインする必要があります'
          ), //"アプリを使用する際、ユーザーIDとパスワードを入力のうえ、ログインする必要があります。",
        },
        {
          id: 2,
          label: vm.$vuetify.lang.t(
            '$vuetify.FECU35ログイン方法設定画面.ユーザーIDは省略しパスワードを入力する'
          ), // "ユーザーIDは省略し、パスワードを入力する",
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU35ログイン方法設定画面.次回ログイン時からパスワードの入力だけでログインできます'
          ), //"次回ログイン時からパスワードの入力だけでログインできます。ユーザーIDの入力欄は、ユーザーIDが入力された状態になります。",
        },
        {
          id: 3,
          label: vm.$vuetify.lang.t(
            '$vuetify.FECU35ログイン方法設定画面.パスコードスマートフォンの生体認証を使う'
          ), // "パスコード・スマートフォンの生体認証を使う",
          text: vm.$vuetify.lang.t(
            '$vuetify.FECU35ログイン方法設定画面.ユーザーIDパスワードの替わりに数字4桁のパスコードだけでログインできます'
          ), //"ユーザーID・パスワードの替わりに数字4桁のパスコードだけでログインできます。スマートフォン搭載の生体認証をご利用の方は、パスコードを設定後、「生体認証を設定」を選択してください。",
        },
      ],
      isSettingFinish: false, // 設定が完了したかどうかを判定するフラグ
      firstRadioGroup: 1, // 初期表示時の選択肢を保持
      callbackResult: {
        loginSetting: {
          errorCode: '',
        },
      },
      pageFrom: '', // どのページから来たのかを保持
      loggedOut: false,
      initialLoginMethod: 0,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU35ログイン方法設定画面.ログイン方法設定'), // "ログイン方法設定",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU35ログイン方法設定画面.C0001'), //"ログイン方法を変更を行うことができます。\nご利用のスマートフォンによっては、生体認証がご利用になれない場合がございます。",
        radioItems: [
          {
            id: 1,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU35ログイン方法設定画面.ユーザーIDパスワードを毎回入力する'
            ), //"ユーザーID、パスワードを毎回入力する",
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU35ログイン方法設定画面.アプリを使用する際ユーザーIDとパスワードを入力のうえログインする必要があります'
            ), //"アプリを使用する際、ユーザーIDとパスワードを入力のうえ、ログインする必要があります。",
          },
          {
            id: 2,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU35ログイン方法設定画面.ユーザーIDは省略しパスワードを入力する'
            ), // "ユーザーIDは省略し、パスワードを入力する",
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU35ログイン方法設定画面.次回ログイン時からパスワードの入力だけでログインできます'
            ), //"次回ログイン時からパスワードの入力だけでログインできます。ユーザーIDの入力欄は、ユーザーIDが入力された状態になります。",
          },
          {
            id: 3,
            label: vm.$vuetify.lang.t(
              '$vuetify.FECU35ログイン方法設定画面.パスコードスマートフォンの生体認証を使う'
            ), // "パスコード・スマートフォンの生体認証を使う",
            text: vm.$vuetify.lang.t(
              '$vuetify.FECU35ログイン方法設定画面.ユーザーIDパスワードの替わりに数字4桁のパスコードだけでログインできます'
            ), //"ユーザーID・パスワードの替わりに数字4桁のパスコードだけでログインできます。スマートフォン搭載の生体認証をご利用の方は、パスコードを設定後、「生体認証を設定」を選択してください。",
          },
        ],
      };
    },
    selectedLoginMethod() {
      return this.radioGroup - 1; // 0: id/pw毎回入力, 1: id省略, 2: パスコード・生体認証
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 設定同意ダイアログ表示
     */
    openAgreementDialog: async function () {
      if (this.selectedLoginMethod === 2) {
        this.$router.push({
          path: '/passcodeSettings',
          query: {
            from: 'loginSettings', // 次の画面に, 本画面からの遷移であることを知らせる
            fromfrom: this.pageFrom, // 次の画面に、本画面がどの画面からの遷移であることを知らせる
          },
        });
      } else {
        const result = await this.$agreementDialog(
          '$vuetify.agreementDialog.確認',
          '$vuetify.メッセージ一覧.FECU35ログイン方法設定画面.C0002',
          '$vuetify.agreementDialog.いいえボタン',
          '$vuetify.agreementDialog.はいボタン'
        );

        if (result) {
          this.$_setLoading(true);
          // ログイン設定記録
          // この関数発火時にはthis.selectedLoginMethod !== 2が保証されている
          NativeApi.registerLoginSetting(this.selectedLoginMethod, '', ''); // -> watch"callbackResult.loginSetting"
        }
      }
    },
    /**
     * 画面遷移処理
     * @param {string} url 画面遷移先パス
     */
    push(url) {
      this.$router.push({
        path: url,
        //query: { hoge_token: data }
      });
    },
  },
  watch: {
    // IF02のCallbackを監視
    async 'callbackResult.loginSetting'(newVal, oldVal) {
      if (oldVal.errorCode !== '') return;

      this.$_setLoading(false);
      if (NativeCallback.codeInclude(newVal.errorCode, '02-C0000')) {
        this.isSettingFinish = true;
        await this.$informationDialog('$vuetify.メッセージ一覧.FECU35ログイン方法設定画面.C0003');

        if (this.pageFrom === 'twoStepAuthentication') {
          if (sessionStorage.getItem('redirectPath')) {
            // redirect to notificationHistory page when tap from panel
            this.$router.push({
              path: sessionStorage.getItem('redirectPath'),
            });
          } else {
            this.push('/top');
          }
        } else if (this.pageFrom === 'variousSettings') {
          this.push('/variousSettings');
        }
      } else if (NativeCallback.codeInclude(newVal.errorCode, '02-E0001')) {
        // パスコード不一致の場合、Native側で再度実行させる -> 無限ループにはいるのでは?
        NativeApi.registerLoginSetting(this.selectedLoginMethod, '', '');
      } else if (NativeCallback.codeInclude(newVal.errorCode, '02-E9999')) {
        this.push('/sorry');
      }
    },
    deep: true,
  },
  beforeMount() {
    // Native部との通信を行うCallback関数をwindowオブジェクトに登録
    // IF02_ログイン設定記録要求
    window.onRegisterLoginSettingFinished = (errorCode) => {
      this.callbackResult.loginSetting = NativeCallback.onRegisterLoginSettingFinished(errorCode);
    };
    window.onResponseNativeAppInfo = (error, version, login) => {
      this.initialLoginMethod = login;
      this.radioGroup = login * 1 + 1;
    };
  },
  async mounted() {
    NativeApi.requestNativeAppInfo();

    if (!this.$isMobileApp) {
      this.$router.replace({
        path: '/sorry',
      });
    }

    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);
    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }
    // 初期表示時、ラジオボックスを、Nativeからのコールバックと同じ値にセットすべきではあるが、仕様書にないので未設定とする
    this.firstRadioGroup = 1;
    // 前ページからのクエリを受け取る
    this.pageFrom = this.$route.query.from;
    const element = document.querySelectorAll('[class*="humburger-menu__button"]');
    const header = this.$refs.header;
    let newLastChild;
    if (!newLastChild) {
      element.forEach((e) => {
        e.addEventListener('click', () => {
          setTimeout(() => {
            const listitem = document.querySelectorAll('[class*="v-list-item "]');
            let lastchild = listitem[listitem.length - 1].querySelector('button');
            newLastChild = lastchild.cloneNode(true);
            lastchild.parentNode.replaceChild(newLastChild, lastchild);
            newLastChild.addEventListener('click', async () => {
              const result = await this.$agreementDialog(
                '$vuetify.agreementDialog.確認',
                '$vuetify.メッセージ一覧.FECU35ログイン方法設定画面.C0004',
                '$vuetify.agreementDialog.いいえボタン',
                '$vuetify.agreementDialog.はいボタン'
              );
              if (result === true) {
                this.loggedOut = true;
                header.logout();
              } else {
                return false;
              }
            });
          }, 50);
        });
      });
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (to.path !== '/passcodeSettings') {
      if (this.selectedLoginMethod == this.initialLoginMethod) {
        next();

        return;
      }

      if (
        this.isSettingFinish === false &&
        this.radioGroup !== this.initialLoginMethod &&
        !this.loggedOut
      ) {
        const result = await this.$agreementDialog(
          '$vuetify.agreementDialog.確認',
          '$vuetify.メッセージ一覧.FECU35ログイン方法設定画面.C0004',
          '$vuetify.agreementDialog.いいえボタン',
          '$vuetify.agreementDialog.はいボタン'
        );
        if (result === true) {
          next();
        } else {
          // ダイアログが閉じられる
        }
      } else {
        next();
      }
    } else {
      next();
    }
  },
};
